import * as React from "react";
import { styled, IconButton } from "@mui/material";
import clsx from "clsx";

//region [[ Styles ]]

const IconButtonWrapper = styled(IconButton)({
  "& .MuiIconButton-label": {
    display: "flex",
    flexFlow: "column",
    justifyContent: "center",
    alignItems: "center",
    color: "white",
  },
  "&.Mui-disabled": {
    opacity: "0.4",
  },
});

const Label = styled("span")({
  margin: "3px",
  fontSize: "12px",
  lineHeight: "4px",
  fontWeight: 300,
});

//endregion [[ Styles ]]

//region [[ Props ]]

export interface JsonEditButtonProps {
  className?: string;
  icon?: React.ReactNode;
  label?: string;
  onClick: (e) => void;
  disabled?: boolean;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const JsonEditButton = ({ ...props }: JsonEditButtonProps) => {
  return (
    <IconButtonWrapper
      className={clsx(props.className, "")}
      onClick={props.onClick}
      disabled={props.disabled}
    >
      {props.icon}
      {props.label && props.label !== "" && <Label>{props.label}</Label>}
    </IconButtonWrapper>
  );
};
